<script>
	import { onMount, createEventDispatcher } from 'svelte'
	import moment from 'moment'

	export let start
	export let end
	export let months = 120

	let months_s = [],
		months_e = [],
		mmnt_s = moment().add(2, 'month').startOf('month'),
		mmnt_e = moment().add(2, 'month').endOf('month'),
		internalState = {
			start: 0,
			end: 0
		},
		publicState = {
			start: 0,
			end: 0
		}

	const dispatch = createEventDispatcher()

	const onChange = (event) => {
		const { name, value } = event.target
		// console.log ('onChange', name, value)
		internalState[name] = value
		exportState(value, name)
	}

	const epochToPS = (epoch, name) => {
		return moment(epoch).format('MM/YYYY')
	}

	const psToEpoch = (ps, name) => {
		let m = moment(ps, 'MM/YYYY')

		if (name === 'start') m.startOf('month')
		else m.endOf('month')

		return m.valueOf()
	}

	const importState = (d, name) => {
		// console.log ('importState', name, d, epochToPS (d, name))
		internalState[name] = epochToPS(d, name)
	}

	const exportState = (d, name) => {
		// console.log ('exportState', name)
		publicState.start = psToEpoch(internalState.start, 'start')
		publicState.end = psToEpoch(internalState.end, 'end')
		triggerChange()
	}

	const triggerChange = () => {
		// console.log ('period-change', publicState)
		dispatch('period-change', publicState)
	}

	$: {
		importState(start, 'start')
	}

	$: {
		importState(end, 'end')
	}

	onMount(() => {
		for (var j = 0; j < months; j++) {
			months_s.unshift({ text: mmnt_s.format('MMMM YYYY'), value: mmnt_s.format('MM/YYYY') })
			months_e.unshift({ text: mmnt_e.format('MMMM YYYY'), value: mmnt_e.format('MM/YYYY') })

			mmnt_s.subtract(1, 'months').startOf('month')
			mmnt_e.subtract(1, 'months').endOf('month')
		}
		months_s = months_s
		months_e = months_e
	})
</script>

<div class="PeriodSelector">
	<!-- svelte-ignore a11y-no-onchange -->
	<select class="dropdown start" name="start" value={internalState.start} on:change={onChange}>
		{#each months_s as month (month.value)}
			<option value={month.value}>{month.text}</option>
		{/each}
	</select>
	<!-- svelte-ignore a11y-no-onchange -->
	<select class="dropdown end" name="end" value={internalState.end} on:change={onChange}>
		{#each months_e as month (month.value)}
			<option value={month.value}>{month.text}</option>
		{/each}
	</select>
</div>

<style>
	.PeriodSelector {
		height: 30px;
		padding: 0;
		border-radius: 0;
		border: 0;
		outline: 0;
		font-size: 14px;
		font-weight: 600;
		color: #586d7d;
		/* background-color: #dbe4ea; */
		-webkit-appearance: none;
		border-radius: 2px;
		background-color: var(--sidelink-hover);
		position: relative;
	}

	.PeriodSelector .dropdown {
		display: inline-block;
		border: none;
		outline: none;
		color: #586d7d;
		font-size: 13px;
		font-weight: 600;
		padding: 5px 10px;
		margin: 0;
		background: transparent;
		-webkit-appearance: none;
	}

	.PeriodSelector .start {
		position: absolute;
		top: 0;
		left: 0;
		padding-right: 0;
	}
	.PeriodSelector .end {
		position: absolute;
		top: 0;
		right: 0;
		padding-left: 0;
		text-align: right;
	}
</style>
